import { render, staticRenderFns } from "./DanhSachChucVu.vue?vue&type=template&id=1c49b1b0&"
import script from "./DanhSachChucVu.vue?vue&type=script&lang=js&"
export * from "./DanhSachChucVu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports